
import Vue from 'vue'

export default Vue.extend({
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    textLinks() {
      const locale = this.$i18n.locale
      const supported = ['en', 'es', 'fr', 'pt', 'de']
      const suffix = supported.includes(locale) ? `-${locale}` : ''

      const buildUrl = slug =>
        `https://media.cving.com/${slug}${suffix}/`

      return [
        { name: 'Privacy', link: buildUrl('privacy-policy') },
        { name: this.$t('footer.termsAndConditions').toString(), link: buildUrl('terms-conditions') },
        { name: this.$t('footer.transparency').toString(), link: 'https://media.cving.com/trasparenza/' },
        { name: this.$t('footer.cookiePolicy').toString(), link: 'https://media.cving.com/cookie-declaration/' }
      ]
    }

  },
  methods: {
    handleLinkClick(link: { link?: string }) {
      if (link.link) {
        const newWindow = window.open(link.link, '_blank')
        if (newWindow) {
          newWindow.opener = null
          newWindow.focus()
        }
      }
    }
    /*     toggleCookies() {
      document.body.classList.toggle('show-cookies')
    } */
  }
})
